import { createFileRoute } from '@tanstack/react-router';
import { VerifyPage } from '@/components/verify/VerifyPage';

export const Route = createFileRoute('/verify/')({
  component: VerifyIndex,
});

function VerifyIndex() {
  return <VerifyPage />;
}
